
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pour le Parti bourgeois-démocratique, les élections ont été un désastre: la délégation du Conseil national est passée de sept à trois personnes. Une lueur d'espoir: le président Martin Landolt a été élu avec un résultat brillant.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;